<!-- Chat open button -->
<div class="fixed bottom-6 right-6" [ngClass]="{'d-none':chatOpen, 'z-100': !chatOpen}">
    <button
        class="outline-none bg-primary-blue border-none flex justify-center items-center w-14 h-14 rounded-md animate-fast shadow-lg"
        (click)="openChatSupport()" [ngClass]="{'expand-w_fade-out':chatOpen}">
        <i class="fa fa-question text-primary-blue text-sm rounded-full bg-white w-6 h-6 p-1 flex justify-center items-center"
            aria-hidden="true"></i>
    </button>
</div>

<!-- Chat modal -->
<div class="z-50 chat-size fixed bottom-6 right-6 rounded-md flex flex-col bg-white shadow-lg animate-delay-fast animate fade-in"
    *ngIf="chatOpen" #chatSupprot>
    <!-- Chat header -->
    <header
        class="bg-primary-blue rounded text-white font-semibold p-3 flex items-center justify-center tracking-wider block w-full">
        <i class="material-icons absolute left-6 cursor-pointer" *ngIf="!pages['chat']"
            (click)="goBack()">arrow_back</i>
        {{chatTitle}}
        <i class="material-icons absolute right-6 cursor-pointer" (click)="closeChatSupport()">close</i>
    </header>


    <!-- Chat message list -->
    <div class="bg-white h-3/5 overflow-y-scroll  p-3" #messageList *ngIf="pages['chat']">
        <ul *ngFor="let messageArray of messages index as i1" class="list-none p-0 list-none">
            <li class="w-full pb-2" *ngFor="let message of messageArray; index as i2">
                <div class="flex items-end" [ngClass]="{'justify-end': message.type === 'user_message'}">
                    <!-- Bot avatar -->
                    <div class="w-12" *ngIf="message.type !== 'faq'">
                        <div *ngIf="message.type !== 'user_message' && i2 == 0"
                            class="w-12 h-12 rounded-full flex justify-center items-center bg-blue-200">
                            <span
                                class="text-primary-blue bg-white flex justify-between px-1 leading-0.5 p-0.5 rounded"><span
                                    class="mr-2">•</span><span>•</span></span>
                        </div>
                    </div>
                    <!-- Message text container -->
                    <div class="flex flex-col w-8/12 ml-3" [ngClass]="{'items-end': message.type === 'user_message'}">
                        <header
                            *ngIf="!isSubsequentSender(i1, i2) && (message.type !== 'user_message' && message.type !== 'post')"
                            class="text-xs font-semibold animate-slow fade-in">
                            Invertoryahead <span>•</span>
                            bot
                        </header>
                        <!-- Bot/User message -->
                        <div *ngIf="message.type !== 'post' && (message.type !== 'faq' && message.type !== 'get_in_touch')"
                            class="rounded-2xl px-3 py-1 w-fit font-semibold text-sm animate-delay animate-slow fade-in"
                            [ngClass]="{'bg-primary-blue text-white': message.type === 'user_message', 'bg-gray-200': message.type === 'bot_message'}">
                            {{message.title}}
                        </div>
                        <!-- Bot post -->
                        <div *ngIf="message.type === 'post'" class="border rounded-2xl px-3 py-1 w-fit font-semibold text-sm animate-delay animate-slow
                            fade-in">
                            <header class="flex items-center">
                                <div class="font-normal text-primary-blue cursor-pointer" (click)="loadFaq(message.id)">
                                    <i class="material-icons text-gray-400 text-sm mr-1 ">library_books</i>
                                    {{parseSymbols(message.title)}}
                                </div>
                            </header>
                        </div>
                        <div *ngIf="message.type === 'get_in_touch'" class="border rounded-2xl w-fit font-semibold text-sm animate-delay animate-slow
                        fade-in">
                            <header class="text-center border-b px-3 py-2">{{message.title}}</header>
                            <div>
                                <div (click)="navigateTo('getInTouch')"
                                    class="flex justify-center text-primary-blue p-3 cursor-pointer">
                                    {{message.link}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
        </ul>

        <ul class=" list-none p-0" *ngIf="chatService.botIsTyping">
            <!-- Bot typing indicator -->
            <li class="w-full pb-2">
                <div class="flex items-end">
                    <!-- Bot avatar -->
                    <div
                        class="w-12 h-12 rounded-full flex justify-center items-center bg-blue-200 transition-all transition-slow">
                        <span
                            class="text-primary-blue bg-white flex justify-between px-1 leading-0.5 p-0.5 rounded"><span
                                class="mr-2">•</span><span>•</span></span>
                    </div>
                    <!-- Message text container -->
                    <div class="flex flex-col w-8/12 ml-3">
                        <header class="text-xs font-semibold animate-slow fade-in">Invertoryahead <span>•</span> bot
                        </header>
                        <div
                            class="bg-gray-200 rounded-xl px-3 w-fit font-semibold text-sm animate-delay animate-slow fade-in">
                            <span
                                class="animate-pulse animate animate-infinite animate-delay-fast inline-block text-lg">•</span>
                            <span
                                class="animate-pulse animate animate-infinite animate-delay inline-block text-lg">•</span>
                            <span
                                class="animate-pulse animate animate-infinite animate-delay-long inline-block text-lg">•</span>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    </div>

    <div class="border-b"></div>
    <!-- Get in touch button -->
    <div class="flex justify-end pt-3 pr-4 animate animate-delay-long fade-in" *ngIf="pages['chat']">
        <button type="button" class="p-2 border border-primary-blue rounded text-primary-blue bg-white"
            (click)="getInTouch()">
            Get in touch
        </button>
    </div>

    <!-- Message textarea -->
    <div class="flex-1 px-4 pb-4 pt-3 w-full" *ngIf="pages['chat']">
        <div class="border p-2 rounded h-full w-full flex flex-col">
            <textarea class="w-full border-none resize-none outline-none text-sm flex-1" [(ngModel)]="question"
                (keydown)="clickedEnter($event)" #messageArea>

            </textarea>
            <div class="flex justify-end">
                <i class="material-icons cursor-pointer" (click)="sendQuestion()">send</i>
            </div>
        </div>
    </div>

    <!-- Get in touch form -->
    <form class="bg-white flex-1 flex flex-col overflow-hidden flex-nowrap" *ngIf="pages['getInTouch']"
        (submit)="sendMessage($event)">
        <div class="h-fit mb-1 p-3">
            <div class="w-full">
                <h6 class="text-primary-blue mb-6">Hi {{chatService.UserState.firstName}}</h6>
                <label for="subject" class="font-semibold mb-2">Subject</label>
                <div class="mb-3">
                    <input name="subject" required type="text" [(ngModel)]="subject"
                        class="rounded-md py-1 px-2 outline-none w-full"
                        [ngClass]="{'border': !errors.subject, 'border-danger': errors.subject}"
                        (keyup)="checkError('subject')">
                </div>
                <label for=" git-message" class="font-semibold mb-2">How can we help you?</label>
                <div class="p-2 rounded" [ngClass]="{'border': !errors.message, 'border-danger': errors.message}">
                    <textarea required rows="8" name="git-message" [(ngModel)]="message"
                        class="w-full resize-none outline-none border-none" (keyup)="checkError('message')"></textarea>
                </div>
            </div>

        </div>

        <div class="h-96 overflow-y-scroll p-3">
            <div class="flex flex-1 items-center text-center px-3 py-2 border rounded-md w-full mb-2">
                <span class="mr-2 font-semibold">To Send Attachments Please Send Email To:
                    support&#64;inventoryahead.com</span>
            </div>
        </div>

        <div class="flex flex-1 items-center p-3 justify-end shadow-lg rounded-md bg-white">
            <button class="text-center w-20 text-white bg-primary-blue outline-none border rounded-md" type="submit"
                [innerHTML]="messageSendHtml">
            </button>
        </div>
    </form>

    <!-- Message sent success message page -->
    <div *ngIf="pages['messageSentSuccess']" class="flex flex-col justify-center items-center pt-20">
        <svg viewBox="0 0 163 81.09" class="w-64 h-64">
            <defs>
                <style>
                    .custom-cls-1 {
                        fill: #ccc
                    }

                    .cls-2 {
                        fill: #cccccb
                    }

                    .cls-3 {
                        fill: #f8f8f8
                    }

                    .cls-4 {
                        fill: none
                    }

                    .cls-5 {
                        fill: #30aabc
                    }
                </style>
            </defs>
            <g id="Layer_2" data-name="Layer 2">
                <g id="Layer_1-2" data-name="Layer 1">
                    <path class="custom-cls-1"
                        d="M35.5 5.26A2.5 2.5 0 1138 2.76 2.5 2.5 0 0135.5 5.26zm0-4A1.5 1.5 0 1037 2.76 1.5 1.5 0 0035.5 1.26zM138.49 32.76a3 3 0 113-3A3 3 0 01138.49 32.76zm0-5a2 2 0 102 2A2 2 0 00138.49 27.76z">
                    </path>
                    <path class="cls-2"
                        d="M159 39.76h-1.5v-1.5a1 1 0 10-2 0v1.5H154a1 1 0 000 2h1.5v1.5a1 1 0 002 0v-1.5H159a1 1 0 000-2zM132.49 6.76h-3v-3a1 1 0 00-2 0v3h-3a1 1 0 000 2h3v3a1 1 0 102 0v-3h3a1 1 0 000-2zM31.5 26.76h-3v-3a1 1 0 00-2 0v3h-3a1 1 0 000 2h3v3a1 1 0 102 0v-3h3a1 1 0 000-2z">
                    </path>
                    <circle class="custom-cls-1" cx="161.5" cy="18.66" r="1.5"></circle>
                    <circle class="custom-cls-1" cx="1.5" cy="17.76" r="1.5"></circle>
                    <circle class="custom-cls-1" cx="11.5" cy="45.76" r="2"></circle>
                    <path class="cls-3"
                        d="M126.07,71.09h-6v.1a5,5,0,0,1-5,5H53a5,5,0,0,1-5-5v-.1h-7a5,5,0,1,0,0,10h85a5,5,0,0,0,0-10Z">
                    </path>
                    <path class="cls-4"
                        d="M52.73 29.19L52.29 29.59 53.02 30.27 53.02 28.92 52.99 28.95 52.99 29.44 52.73 29.19z">
                    </path>
                    <path class="cls-4"
                        d="M52.99 29.44L52.99 28.95 52.73 29.19 52.99 29.44zM71 59.62l1.46-1 4.83-3.32L55 34.82l-1-.92L53 33l-2.21-2A3.78 3.78 0 0050 33.19v37.9h4.32L69.59 60.62zM92.62 8.62h0L86.47 3A3.68 3.68 0 0084 2h0a3.68 3.68 0 012.43 1z">
                    </path>
                    <path class="cls-4"
                        d="M75.39 8.62H92.62L86.44 3A3.68 3.68 0 0084 2a3.65 3.65 0 00-2.43 1zM115.02 30.3L115.02 30.32 115.77 29.63 115.02 28.94 115.02 28.97 115.74 29.63 115.02 30.3z">
                    </path>
                    <path class="cls-4"
                        d="M115.74 29.63L115.02 28.97 115.02 30.3 115.74 29.63zM80.55 53.08a6.26 6.26 0 017 0l1.53 1.06 23.94-22V11.62a1 1 0 00-1-1H56a1 1 0 00-1 1h0a1 1 0 011-1h0a1 1 0 00-1 1v12.8h0v1.35h0V32.1l24 22zM71.77 29.45a1.13 1.13 0 011.63.12l7.33 8.28L97.37 20.12A1.15 1.15 0 0199 21.75L81.54 40.42a1.05 1.05 0 01-.81.35 1.33 1.33 0 01-.93-.35l-8.15-9.33A1.14 1.14 0 0171.77 29.45zM117.26 31L115 33 114 34l-1 .92L90.78 55.3l4.83 3.32 1.45 1 1.46 1 15.24 10.47H118V33.19A3.78 3.78 0 00117.26 31z">
                    </path>
                    <path class="cls-4"
                        d="M93.53,59.62l-1.46-1-5.65-3.89A4.31,4.31,0,0,0,84,54a4.23,4.23,0,0,0-2.35.72L76,58.62l-1.46,1-1.45,1L57.87,71.09h52.36L95,60.62Z">
                    </path>
                    <path class="cls-2"
                        d="M117.7,28.68,115,26.24V11.62a3,3,0,0,0-3-3H95.62l-7.81-7.1A5.72,5.72,0,0,0,84.05,0H84a5.72,5.72,0,0,0-3.76,1.52l-7.81,7.1H56a3,3,0,0,0-3,3V26.24l-2.68,2.44A5.55,5.55,0,0,0,48,33.19v38a5,5,0,0,0,5,5h62a5,5,0,0,0,5-5v-38A5.56,5.56,0,0,0,117.7,28.68Zm-2.71.26,0,0v0l.75.69-.75.69v0l0,0ZM81.54,3A3.68,3.68,0,0,1,84,2h0a3.68,3.68,0,0,1,2.45,1l6.18,5.62H75.36ZM55,27.1V25.77h0V24.42h0V11.62h0a1,1,0,0,1,1-1h56a1,1,0,0,1,1,1V32.16l-23.94,22-1.53-1.06a6.26,6.26,0,0,0-7,0L79,54.14l-24-22Zm-2,1V29l0,0v1.35l-.73-.68.43-.4-.46-.43Zm-2,45.3a3,3,0,0,1-1-2.2v-38A3.78,3.78,0,0,1,50.81,31L53,33l1,.92,1,.92L77.33,55.3,72.5,58.62l-1.46,1-1.45,1L54.34,71.09Zm2.37.8,4.5-3.1L73.12,60.62l1.45-1,1.46-1,5.66-3.89A4.23,4.23,0,0,1,84,54a4.31,4.31,0,0,1,2.38.72l5.65,3.89,1.46,1,1.46,1,15.24,10.47,4.5,3.1Zm64.65-3a3,3,0,0,1-1,2.17l-3.31-2.27L98.52,60.62l-1.46-1-1.45-1L90.78,55.3,113,34.88l1-.92,1-.92L117.26,31a3.78,3.78,0,0,1,.76,2.21v38Z">
                    </path>
                    <path class="cls-2"
                        d="M52.99 28.95L52.99 28.09 52.26 28.76 52.73 29.19 52.99 28.95zM115.02 28.97L114.99 28.94 114.99 30.32 115.02 30.3 115.02 28.97zM92.62 8.62H75.39L81.58 3A3.65 3.65 0 0184 2h0a3.68 3.68 0 00-2.45 1L75.36 8.62z">
                    </path>
                    <path class="cls-5 customColor"
                        d="M80.73,40.77a1.05,1.05,0,0,0,.81-.35L99,21.75a1.15,1.15,0,0,0-1.63-1.63L80.73,37.85,73.4,29.57a1.16,1.16,0,1,0-1.75,1.52l8.15,9.33A1.33,1.33,0,0,0,80.73,40.77Z">
                    </path>
                </g>
            </g>
        </svg>
        <h5 class="font-semibold text-primary-blue mb-3">Thanks for reaching out</h5>
        <h5 class="mb-6">Somone will get back to you soon</h5>

        <h5 class="text-primary-blue border-none outline-none bg-none block cursor-pointer"
            (click)="navigateTo('chat')">
            Go Back
        </h5>

    </div>


    <!-- FAQ Page -->
    <div *ngIf="pages['faq']" class="flex-1 overflow-y-scroll p-3 w-full">
        <header class="mb-2">
            <h4 class="">{{parseSymbols(faq.title.rendered)}}</h4>
            <a [href]="faq.link" class="text-primary-blue mr-1" target="_blank">See inventoryahead FAQ page <fa-icon
                    [icon]="faExternalLink">
                </fa-icon></a>
        </header>
        <div [innerHTML]="faq.content.rendered" class="">

        </div>
    </div>

</div>